import { AppOutlinedButton } from "../../../../global/ui/buttons";
import { DefaultLoadingComponent } from "../../../../global/defaultLoading/DefaultLoadingComponent";
import { useEffect, useState } from "react";
import { useBlogNavigationContext } from "../../blogTabs";
import { useBlogCoachCardContext } from "./BlogCoachCardProvider";
import { followCoach, unfollowCoach } from "../../../../../api/coaches";
import useUser from "../../../../../hooks/user/useUser";

export const BlogCoachCardFollow = () => {
  const [isFollowing, setIsFollowing] = useState<boolean>(null);
  const { state } = useBlogNavigationContext();
  const cardContext = useBlogCoachCardContext();
  const { user } = useUser();

  const handleFollow = async () => {
    if (isFollowing) {
      setIsFollowing(false);

      await unfollowCoach(cardContext.state.coach.id, user.token);

      return;
    }

    if (!isFollowing) {
      setIsFollowing(true);

      await followCoach(cardContext.state.coach.id, user.token);

      return;
    }
  };

  useEffect(() => {
    if (
      state.followingCoaches.rows.find(
        (item) => item.id === cardContext.state.coach.id,
      )
    ) {
      setIsFollowing(true);
      return;
    }

    setIsFollowing(false);
  }, [cardContext.state.coach.id, state.followingCoaches.rows]);

  if (isFollowing === null) {
    return <DefaultLoadingComponent className={"h-10"} />;
  }

  if (isFollowing) {
    return (
      <AppOutlinedButton
        className={"ml-auto"}
        onClick={() => void handleFollow()}
      >
        Unfollow
      </AppOutlinedButton>
    );
  }

  return (
    <AppOutlinedButton
      className={"ml-auto"}
      onClick={() => void handleFollow()}
    >
      Follow
    </AppOutlinedButton>
  );
};
